
import { Component, Vue } from 'vue-property-decorator';
import storage from 'baimahu/storage';

@Component
export default class Index extends Vue {
  get year(): number {
    return new Date().getFullYear();
  }

  get is_active_xdb(): string {
    return this.$route.path === '/' ? 'active' : '';
  }
  get is_active_oa(): string {
    return this.$route.path === '/oa' ? 'active' : '';
  }
  get profile(): any {
    return storage.getItem('profile');
  }
  get avatar(): string {
    let avatar = 'https://static.tugou.com/logo/160.png';
    if (this.profile && this.profile.avatar) {
      avatar = this.profile.avatar;
    }
    console.debug('avatar:', avatar);
    return avatar;
  }
  get name(): string {
    return this.profile ? this.profile.name : '请登录';
  }
  get is_login(): boolean {
    return this.$route.path === '/passport' ? false : true;
  }
}
